import { Component } from '@angular/core';


export class SkyRadioDemoComponent {
  public selectedValue = '3';
  public valueGuy = '2';
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-radio-demo',
  template: `<form #checkForm="ngForm">
  <div>
    <fieldset>
      <legend>Radio button options</legend>
      <ul class="sky-list-unstyled">
        <li>
          <sky-radio name="radiotest" [(ngModel)]="selectedValue" #cb="ngModel" value="1">
            <sky-radio-label>Option 1</sky-radio-label>
          </sky-radio>
        </li>

        <li>
          <sky-radio
            name="radiotest"
            [ngModel]="selectedValue"
            (ngModelChange)="selectedValue = $event"
            disabled="true"
            [value]="valueGuy">
            <sky-radio-label>Option 2</sky-radio-label>
          </sky-radio>
        </li>

        <li>
          <sky-radio name="radiotest" [ngModel]="selectedValue" (ngModelChange)="selectedValue = $event" value="3">
            <sky-radio-label>Option 3</sky-radio-label>
          </sky-radio>
        </li>
      </ul>
    </fieldset>

    <br />
    Selected option: {{selectedValue}}
    Touched: {{cb.touched}}
    Pristine: {{cb.pristine}}
  </div>
</form>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
